import { envConfig } from "@/config";
import { frontendDomains } from "./getBackendUrl";

export function getCoursesMicrofrontendUrl(frontendDomain: string): string {
	if (process.env.NODE_ENV === "development" && envConfig.COURSES_MFE_URL_OVERRIDE) return envConfig.COURSES_MFE_URL_OVERRIDE;

	if (frontendDomains.sit.includes(frontendDomain)) return envConfig.COURSES_MFE_URL_SIT;
	if (frontendDomains.stg.includes(frontendDomain)) return envConfig.COURSES_MFE_URL_STG;
	if (frontendDomains.ause1.includes(frontendDomain)) return envConfig.COURSES_MFE_URL_AUSE1;
	if (frontendDomains.usce1.includes(frontendDomain)) return envConfig.COURSES_MFE_URL_USCE1;
	if (frontendDomains.euwe2.includes(frontendDomain)) return envConfig.COURSES_MFE_URL_EUWE2;

	// Default to SIT region
	return envConfig.COURSES_MFE_URL_SIT;
}

export function getAcademyMicrofrontendUrl(frontendDomain: string): string {
	if (process.env.NODE_ENV === "development" && envConfig.ACADEMY_MFE_URL_OVERRIDE) return envConfig.ACADEMY_MFE_URL_OVERRIDE;

	if (frontendDomains.sit.includes(frontendDomain)) return envConfig.ACADEMY_MFE_URL_SIT;

	// Default to PRD for all other domains
	return envConfig.ACADEMY_MFE_URL_PRD || "https://academy.digital-learning-content.qoria.cloud/assets/remoteEntry.js";
}
